import { useTheme } from '@emotion/react'
import {
    SectionMetaInfoDTO,
    SectionMetaDTO,
} from '@west-australian-newspapers/publication-types'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'

export function getSectionMetaInfo(
    sectionMeta: SectionMetaDTO,
    section: string,
) {
    const sectionInfo: SectionMetaInfoDTO = {
        ...sectionMeta.defaultSectionMeta,
        ...(sectionMeta.sectionOverrides as any)[section],
    }

    return sectionInfo
}
